import { apiClient } from '@src/services/http-common'
import { InteracWire, InteracWireHistoryFiltersType } from '@src/types/interac'
import { useQuery } from '@tanstack/react-query'

async function getInteracWireHistory(filters: InteracWireHistoryFiltersType) {
  const response = await apiClient.post<InteracWire[]>('/GetInteracWireHistory', filters)
  return response.data ?? []
}

const EMPTY_ARRAY: InteracWire[] = []

export function useInteracWireHistory(filters: InteracWireHistoryFiltersType): [InteracWire[], boolean, Error | null] {
  const { data, isFetching, error } = useQuery({
    queryKey: ['interacWireHistory', filters],
    queryFn: () => getInteracWireHistory(filters),
    enabled: !!filters,
    placeholderData: EMPTY_ARRAY,
  })
  return [data ?? EMPTY_ARRAY, isFetching, error]
}
